export const LOADING_LOVS = "getStartedPage_LOADING_LOVS";
export const LOVS_LOADED = "getStartedPage_LOVS_LOADED";
export const LOADING_CITIES = "getStartedPage_LOADING_CITIES";
export const CITIES_LOADED = "getStartedPage_CITIES_LOADED";
export const UPDATE_CREATING_LEAD = "getStartedPage_UPDATE_CREATING_LEAD";
export const UPDATE_LOADING_COUNTRIES= "getStartedPage_UPDATE_LOADING_COUNTRIES";
export const COUNTRIES_LOADED = "getStartedPage_COUNTRIES_LOADED";